import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {ReservationData} from "../../models/reservationData";
import {ReservationDataService} from "../../services/reservationData.service";

@Injectable()
export class ReservationDataResolve implements Resolve<ReservationData> {
    constructor(private reservationDataService: ReservationDataService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<ReservationData> {
        return this.reservationDataService.getById(route.params.id);
    }
}
